import * as fb from '../firebase';

const STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
};

export default {
  status: STATUS,

  getRef(bucketId) {
    return fb.bucketsCollection.doc(bucketId);
  },

  /**
   * Récupère un panier
   * @param {*} bucketId
   */
  getBucket(bucketId) {
    return this.getRef(bucketId)
      .get()
      .then((bucket) => {
        if (bucket.exists) {
          return {
            id: bucketId,
            ...bucket.data(),
          };
        }
        return null;
      });
  },

  /**
   * Modifie un panier
   * @param {*} bucketId
   * @param {*} data
   */
  updateBucket(bucketId, data) {
    data.updatedOn = new Date();
    return this.getRef(bucketId).update(data);
  },

  /**
   * Crée un panier
   */
  createBucket(data = {}) {
    if (!data.creatorId) {
      data.creatorId = fb.auth.currentUser.uid;
    }
    if (!data.createdOn) {
      data.createdOn = new Date();
    }
    data.updatedOn = new Date();
    data.status = this.status.OPEN;
    return fb.bucketsCollection.add(data);
  },

  /**
   * Récupère tous les paniers avec un certain statut
   */
  getBuckets(status = this.status.OPEN, orderBy = 'createdOn') {
    const userId = fb.auth.currentUser.uid;
    return fb.bucketsCollection
      .where('status', '==', status)
      .where('creatorId', '==', userId)
      .orderBy(orderBy, 'desc')
      .get()
      .then((res) => {
        return res.docs
          .filter((bucket) => bucket.exists)
          .map((bucket) => {
            return {
              id: bucket.id,
              ...bucket.data(),
            };
          });
      });
  },
  /**
   * Récupère tous les paniers avec le statut "open"
   */
  getOpenBuckets() {
    return this.getBuckets(this.status.OPEN);
  },

  /**
   * Récupère tous les paniers avec le statut "closed"
   */
  getClosedBuckets() {
    return this.getBuckets(this.status.CLOSED);
  },
};
